import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import * as gridStyles from "@faire/retailer/components/SDUI/ComponentRenderers/Grid/__internal__/styles.css";
export var ProductTileRowPlaceholder = function(param) {
    var placeholderStyles = param.placeholderStyles;
    return /*#__PURE__*/ _jsx("div", {
        className: gridStyles.productTileRowPlaceholder,
        style: placeholderStyles,
        "data-test-id": "product-tile-row-placeholder"
    });
};
export var BrandTileRowPlaceholder = function(param) {
    var placeholderStyles = param.placeholderStyles;
    return /*#__PURE__*/ _jsx("div", {
        className: gridStyles.brandTileRowPlaceholder,
        style: placeholderStyles
    });
};
